type IPlayState = 'PAUSED' | 'PLAYING'

export function iheartPlayer ({ onPlay }: { onPlay: () => void }) {
  let playStateOnOpen: IPlayState = 'PAUSED'
  
  function getPlayButtons () {
    try {
      const musicPlayerFrame = document.querySelector('#ihr-player-bar-frame') as HTMLIFrameElement
      const musicPlayerDocument = musicPlayerFrame && musicPlayerFrame.contentWindow && musicPlayerFrame.contentWindow.document || document
      const playButtons = Array.from(musicPlayerDocument.querySelectorAll('[data-test=play-button]')) as (HTMLButtonElement & { playListener: boolean })[]
      return playButtons
    } catch (err) {
      return []
    }
  }

  function getPlayState (element: HTMLButtonElement) {
    if (element) {
      const state = element.getAttribute('data-test-state')
      if (state) return state as IPlayState
  
      const label = element.getAttribute('aria-label')
      if (label && label.toLowerCase().indexOf('pause') === 0) return 'PLAYING'
    }
  
    return 'PAUSED'
  }

  function claimAudio () {
    // STOP IHEART PLAYER SO WE CAN PLAY
    const playButtons = getPlayButtons()
    if (playButtons[0]) {
      playStateOnOpen = getPlayState(playButtons[0])
      if (playStateOnOpen === 'PLAYING') {
        playButtons[0].click()
      }
    }

    listenForPlay()
  }

  function releaseAudio () {
    // ALLOW IHEART PLAYER TO PLAY
    const playButtons = getPlayButtons()
    if (playButtons[0] && playStateOnOpen === 'PLAYING') {
      playButtons[0].click()
    }
  }

  function listenForPlay () {
    const playButtons = getPlayButtons()
    for (const playButton of playButtons) {
      if (!playButton.playListener) {
        playButton.playListener = true;
        if (getPlayState(playButton) === 'PLAYING') onPlay()
        playButton.addEventListener('click', () => {
          onPlay()
        });
      }
    }
  }

  setTimeout(() => {
    listenForPlay()
  }, 4000)

  return {
    claimAudio,
    releaseAudio,
  }
}